import { useCallback, useEffect } from "react";
import { useUsabilla } from "./useUiMUsabilla";

declare global {
  interface Window {
    usabilla_live: any;
  }
}

globalThis.window.usabilla_live = globalThis.window.usabilla_live || null;

// Use the Usabilla object - "window.usabilla_live" - to either "show" or "hide"
// ie. window.usabilla_live("show") or window.usabilla_live("hide")

const UiMUsabilla = () => {
  const { usabillaVisibility } = useUsabilla();

  const loadUsabilla = useCallback(async (): Promise<any> => import("./usabilla"), []);

  const initialiseUsabilla = useCallback(async (): Promise<any> => {
    await loadUsabilla()
      .then(() => {
        console.log("Usabilla has been embedded");
        if (globalThis.window.usabilla_live) {
          globalThis.window.usabilla_live("hide");
        }
      })
      .catch(() => console.warn("Usabilla script did not load"));
  }, [loadUsabilla]);

  useEffect(() => {
    initialiseUsabilla();
  }, [initialiseUsabilla]);

  useEffect(() => {
    if (globalThis.window.usabilla_live) {
      globalThis.window.usabilla_live(usabillaVisibility);
    }
  }, [usabillaVisibility]);

  return null;
};

export default UiMUsabilla;
